import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useContext, useEffect } from "react";
import { ConfigurationParentEventId, isConfigurationParentEvent, } from "@plansoft-configuration-renderer/events";
import { reloadConfiguration } from "../actions/reloadConfiguration";
import { CFG_EVENT, ConfigurationEventEmitterContext, } from "../context/ConfigurationEventEmitterContext";
import { useConfigurationDispatch } from "../context/ConfigurationReduxContext";
export function ConfigurationFrameController() {
    const dispatch = useConfigurationDispatch();
    const configurationEventEmitter = useContext(ConfigurationEventEmitterContext);
    const reloadCallback = useCallback(() => {
        dispatch(reloadConfiguration());
    }, [dispatch]);
    useEffect(() => {
        function messageEventHandler(event) {
            // skip child events
            if (!isConfigurationParentEvent(event)) {
                return;
            }
            switch (event.cfgEvent) {
                case ConfigurationParentEventId.ConfigurationReload: {
                    return reloadCallback();
                }
            }
        }
        // attach event handler for message events
        configurationEventEmitter.on(CFG_EVENT, messageEventHandler);
        return () => {
            // detach event handler for message events
            configurationEventEmitter.off(CFG_EVENT, messageEventHandler);
        };
    }, [configurationEventEmitter, reloadCallback]);
    return _jsx(Fragment, {});
}
//# sourceMappingURL=ConfigurationFrameController.js.map